module.exports = __webpack_public_path__ + "img/icon_1_18.3d7f0810.png";